import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiGet, apiPost } from "utilities/api";
import { SCOPES } from "utilities/constants/constants";

export const fetchNotifications = createAsyncThunk(
	"notifications/fetchAll",
	apiGet<{ message: string; data: any[] }>(
		(authConfig) => authConfig.FUNCTION_API_ENDPOINTS.NOTIFICATION_CENTER_USERS(),
		[SCOPES.FUNCTION_READ],
	),
);

export const saveNotifications = createAsyncThunk(
	"notifications/save",
	apiPost(
		(authConfig) => authConfig.FUNCTION_API_ENDPOINTS.NOTIFICATION_CENTER_USERS(),
		[SCOPES.FUNCTION_WRITE],
	),
);
